<main>
    <div class="row register step-1" [ngClass]="{'fly-out': registerService._isFlyout}">
        <div class="col center">
            <h1>
                Membership has
                <span class="block bold">real privileges!</span>
            </h1>
            <h2>Register to enjoy everything Rankipedia offers</h2>
            <form [formGroup]="frmReg" (submit)="onSubmit()">
                <div class="type-select">
                    <h3>What's your membership type? <em>(All membership types give you access to all features and can be changed later)</em></h3>
                    <div class="row">
                        <div class="col mem-type" [ngClass]="{'selected': this.authService.regModel2.memberType === 1}" (click)="radioChangeHandler(1)">
                            <input type="radio" name="reg-type-select" id="registerConsumer" value="1" #registerConsumer />
                            <label for="registerConsumer">Consumer</label>
                            <p>
                                I am not a business or an organization and I want to be able to share my experiences with others.
                            </p>
                        </div>
                        <div class="col mem-type" [ngClass]="{'selected': this.authService.regModel2.memberType === 5}" (click)="radioChangeHandler(5)">
                            <input type="radio" name="reg-type-select" id="registerProfessional" value="5" #registerProfessional checked />
                            <label for="registerProfessional">Professional</label>
                            <p>
                                I am a business or organization (or represent one) and want to be ranked with others in my industry.
                            </p>
                        </div>
                        <div class="col mem-type" [ngClass]="{'selected': this.authService.regModel2.memberType === 9}" (click)="radioChangeHandler(9)">
                            <input type="radio" name="reg-type-select" id="registerExpert" value="9" #registerExpert />
                            <label for="registerExpert">Expert</label>
                            <p>
                                I'm a blogger, vlogger, reviewer, pundit or consultant to an industry.<br />
                                (Note: requires additional vetting steps for approval.)
                            </p>
                        </div>
                    </div>
                </div>
                <div class="field form-group">
                    <input type="email" id="register-email" placeholder="Email Address" name="Email" formControlName="email" class="form-control ng-valid-email" />
                    <label for="register-email">Email Address</label>
                    <div *ngIf="isLoading" class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                </div>
                <div class="error-container" *ngIf="(Email.errors && (submitted || Email.dirty))">
                    <small class="error" *ngIf="(Email.hasError('required'))">
                        Email is required
                    </small>
                    <small class="error" *ngIf="(Email.hasError('email'))">
                        Please enter a valid email address.
                    </small>
                    <span *ngIf="isValidEmail" id="emailSuccesss" class="sr-only">(success)</span>
                </div>
                <span *ngIf="respModel.emailAlreadyInUse" class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true"></span>
                <div class="form-group error-container" *ngIf="respModel.emailError">
                    <div class="col-sm-12">
                        <small class="error">
                            {{respModel.emailErrorMessage}}
                        </small>
                    </div>
                </div>
                <div class="form-group success-container" *ngIf="respModel.hasProfileToClaim && !respModel.emailAlreadyInUse && isValidEmail">
                    <small class="success">We have located a professional profile that matches your entry. Please continue to claim.</small>
                </div>
                <div class="form-group error-container" *ngIf="respModel.emailAlreadyInUse">
                    <small class="error">There is already an active account for this entry.</small>
                </div>
                <button type="submit" [ngClass]="{'disabled': !isValidEmail}" [disabled]="!isValidEmail" class="btn primary step-1">Continue your registration</button>
            </form>
<!--            <span class="separator">Or</span>
            <div class="row social-registration">
                <div class="col">
                    <a (click)="signInWithFB()" class="social-btn fb">Continue with Facebook</a>
                </div>
                <div class="col">
                    <a (click)="signInWithGoogle()" class="social-btn google">Continue with Google</a>
                </div>
            </div> -->
        </div>
    </div>
</main>
